const GoogleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
        >
            <path
                d="M12.4152 6.13697C12.4152 5.69841 12.3757 5.27877 12.3023 4.87524H6.62598V7.18711L9.89509 7.18782C9.76249 7.95704 9.33577 8.61277 8.68195 9.04992V10.5498H10.6279C11.7642 9.50529 12.4152 7.96124 12.4152 6.13697Z"
                fill="#0F172A"
            />
            <path
                d="M8.68266 9.04987C8.14098 9.41276 7.44343 9.62503 6.62739 9.62503C5.05102 9.62503 3.71375 8.56998 3.23485 7.14783H1.22754V8.69468C2.22203 10.6549 4.26601 12 6.62739 12C8.25947 12 9.63059 11.4668 10.6286 10.5491L8.68266 9.04987Z"
                fill="#0F172A"
            />
            <path
                d="M3.04578 6.00038C3.04578 5.60105 3.11279 5.21504 3.23481 4.85215V3.3053H1.2275C0.816301 4.11585 0.584961 5.03079 0.584961 6.00038C0.584961 6.96996 0.817007 7.8849 1.2275 8.69546L3.23481 7.14861C3.11279 6.78571 3.04578 6.3997 3.04578 6.00038Z"
                fill="#0F172A"
            />
            <path
                d="M6.62739 2.37492C7.51819 2.37492 8.3159 2.67967 8.94574 3.27515L10.6702 1.56366C9.62284 0.594781 8.25736 0 6.62739 0C4.26672 0 2.22203 1.34509 1.22754 3.30527L3.23485 4.85212C3.71375 3.42997 5.05102 2.37492 6.62739 2.37492Z"
                fill="#0F172A"
            />
        </svg>
    );
};

export default GoogleIcon;
